import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import cl from "classnames";
import { OPEN_UP } from "react-dates/constants";
import VsDateRangePicker from "../DateRangePicker";
import VsTimeInput from "../TimeInput";
import classes from "./styles.module.scss";

const DEFAULT_LABEL = "When is your event?";
const DateAndTimeField = ({
  date,
  time,
  onChangeDate,
  onChangeTime,
  disabled,
  endError,
  label = DEFAULT_LABEL,
  className = "",
  allowPast = false,
  extraTimeProps = {},
  TimeComponent = "select",
}) => {
  const { start: startDate, end: endDate } = date;
  const { start: startTime, end: endTime } = time;

  return (
    <div
      className={cl(
        classes.MuiSelectFieldContainer,
        classes.DateAndTimeFieldContainer,
        {
          [classes["MuiSelectFieldContainer--has-value"]]: startDate,
        },
        "form-field",
        className
      )}
    >
      <label className={classes.MuiSelectField__label} htmlFor="date-from">
        {label}
      </label>
      <div>
        <VsDateRangePicker
          withPortal
          value={{
            start: startDate,
            end: endDate,
            // singleDay: formik.values.single_day
          }}
          onChange={onChangeDate}
          disabled={disabled}
          direction={OPEN_UP}
          allowPast={allowPast}
        />

        <div className={classes.TimeInput}>
          <VsTimeInput
            startDate={startDate}
            endDate={endDate}
            startTime={startTime}
            endTime={endTime}
            endError={endError}
            onChange={onChangeTime}
            className={cl(
              classes.Form__select,
              classes.InputGroup__input,
              classes.TimeInput__input
            )}
            extraStartDateProps={extraTimeProps?.start}
            extraEndDateProps={extraTimeProps?.end}
            Component={TimeComponent}
          />
        </div>
      </div>
    </div>
  );
};

DateAndTimeField.propTypes = {
  date: PropTypes.shape({
    start: PropTypes.instanceOf(moment),
    end: PropTypes.instanceOf(moment),
  }).isRequired,
  time: PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string,
  }).isRequired,
  onChangeDate: PropTypes.func.isRequired,
  onChangeTime: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  endError: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  allowPast: PropTypes.bool,
  extraTimeProps: PropTypes.object,
  TimeComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

export default DateAndTimeField;
